// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

.landingContainer_cgpRu {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);
  overflow-y: auto;
}

[class*="section-doc"] {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
}

@media (width < 500px) {
  section {
    min-height: 30vh;
  }
}


@media (width >1800px) {
 [class*="section-doc"] {
   /* min-height: 30vh; */

  }
}





`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Landing/Landing.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;CACC;GACE,sBAAsB;;EAEvB;AACF","sourcesContent":["*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.landingContainer {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  background: linear-gradient(180deg, #ffffff 21%, #f5f5f5 100%);\n  overflow-y: auto;\n}\n\n[class*=\"section-doc\"] {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (width < 500px) {\n  section {\n    min-height: 30vh;\n  }\n}\n\n\n@media (width >1800px) {\n [class*=\"section-doc\"] {\n   /* min-height: 30vh; */\n\n  }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landingContainer": `landingContainer_cgpRu`
};
export default ___CSS_LOADER_EXPORT___;
